var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice-bar",on:{"click":_vm.handleJump}},[_c('div',{staticClass:"notice-bar-icon"}),_c('div',{staticClass:"notice-bar-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }